import { render } from "./SceneInPath.vue?vue&type=template&id=20acb322&scoped=true"
import script from "./SceneInPath.vue?vue&type=script&lang=js"
export * from "./SceneInPath.vue?vue&type=script&lang=js"

import "./SceneInPath.vue?vue&type=style&index=0&id=20acb322&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20acb322"]])

export default __exports__